import * as React from "react";
import { useState, SyntheticEvent } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PageContainer from "../page-container/page-container";
import FilterTypesList from "./filter-types-list";
import ClientVisibility from "./client-visibility";

const TAB_FILTER_TYPES = "filter-types";
const TAB_CLIENT_VISIBILITY = "client-visibility";

interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  activeValue: string;
}

const TabPanel = ({ children, value, activeValue }: TabPanelProps) => (
  <Box
    role="tabpanel"
    hidden={value !== activeValue}
    id={`filter-options-tabpanel-${value}`}
    aria-labelledby={`filter-options-tab-${value}`}
    sx={{ flex: 1, display: "flex", flexDirection: "column", pt: 2 }}
  >
    {value === activeValue && children}
  </Box>
);

const FilterOptions = () => {
  const [activeTab, setActiveTab] = useState(TAB_FILTER_TYPES);

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  return (
    <PageContainer title="Filter Options">
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab
              label="Filter Types & Options"
              value={TAB_FILTER_TYPES}
              id={`filter-options-tab-${TAB_FILTER_TYPES}`}
              aria-controls={`filter-options-tabpanel-${TAB_FILTER_TYPES}`}
            />
            <Tab
              label="Client Visibility"
              value={TAB_CLIENT_VISIBILITY}
              id={`filter-options-tab-${TAB_CLIENT_VISIBILITY}`}
              aria-controls={`filter-options-tabpanel-${TAB_CLIENT_VISIBILITY}`}
            />
          </Tabs>
        </Box>
        <TabPanel value={TAB_FILTER_TYPES} activeValue={activeTab}>
          <FilterTypesList />
        </TabPanel>
        <TabPanel value={TAB_CLIENT_VISIBILITY} activeValue={activeTab}>
          <ClientVisibility />
        </TabPanel>
      </Box>
    </PageContainer>
  );
};

export default FilterOptions;
